var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":_vm.toggle_play_pause}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"mdi",class:[_vm.icon_style, { 'mdi-play': !_vm.is_playing, 'mdi-pause': _vm.is_playing }]})])])}
var staticRenderFns = []

export { render, staticRenderFns }